import styled from 'styled-components'

import { theme } from '../../styles/theme'

export const Container = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  padding: 16px;
  margin-bottom: -80px;

  background-color: ${theme.colors.white};
  box-shadow: 0px 0px 10px 0px rgba(117, 117, 117, 0.1);
  border: 1px solid ${theme.colors.gray100};
  border-radius: ${theme.border.mediumRadius};

  display: flex;
  flex-direction: column;
  gap: 16px;

  position: relative;
  top: -70px;

  @media (min-width: 768px) {
    width: calc(100% - 200px);
    padding: 32px;
  }
`

export const SpanInfo = styled.span`
  font-size: 12px;
  color: ${theme.colors.gray500};
  margin-top: 5px;
`

export const Title = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.gray900};

  @media (min-width: 768px) {
    font-size: ${theme.font.sizes.xlarge};
  }
`

type InputContainerProps = {
  focused?: boolean
}

export const InputContainer = styled.div<InputContainerProps>`
  width: 100%;
  padding: 16px;

  border: 1px solid
    ${(props) => (props.focused ? theme.colors.green1 : theme.colors.gray200)};
  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.white};
  box-shadow: 0px 3px 5px 0px rgba(175, 178, 187, 0.2);

  display: flex;
  flex-direction: column;

  transition: border 0.3s;

  position: relative;

  max-height: 69.19px;

  cursor: pointer;

  input[type='text'] {
    font-size: ${theme.font.sizes.normal};
    font-weight: ${theme.font.normal};
    color: ${theme.colors.gray900};

    cursor: pointer;

    border: none;
    outline: none;

    width: calc(100% - 24px);

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    &::placeholder {
      color: ${theme.colors.gray600};
    }
  }
`

export const InputContainerAvailability = styled.div`
  position: relative;

  width: 100%;

  display: flex;
  gap: 4px;

  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray900};

  svg:hover {
    cursor: pointer;
  }
`

export const Label = styled.div`
  font-size: ${theme.font.sizes.xsmall};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray500};
`

export const Placeholder = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray600};
`

export const Values = styled.div`
  font-size: ${theme.font.sizes.normal};
  font-weight: ${theme.font.normal};
  color: ${theme.colors.gray900};

  //width: calc(100% - 24px);

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const IconContainer = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);

  svg {
    width: 12px;
    height: 6px;

    path {
      fill: ${theme.colors.gray900};
    }
  }
`

export const InputsContainer = styled.div`
  width: 100%;

  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    & > :nth-child(2) {
      grid-column: 1;
      grid-row: 2;
    }

    & > :nth-child(3) {
      grid-column: 2;
      grid-row: 1;
    }
  }
`

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 24px;

  border: none;
  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.green1};

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};

  @media (min-width: 768px) {
    width: 400px;
  }
`

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  padding: 16px;

  border: none;
  border-radius: ${theme.border.mediumRadius};
  background: ${theme.colors.green2};

  font-size: ${theme.font.sizes.medium};
  font-weight: ${theme.font.bold};
  color: ${theme.colors.white};

  @media (min-width: 768px) {
    width: 200px;
  }
`

export const DivButtons = styled.div`
  display: flex;
  gap: 10px;
  flex-direction: column;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: center;
  }
`

export const Wrapper = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: 16px;
`
